import styled from 'styled-components';

export const NA = styled.span`
    color: var(--gray60);
`;
